// extracted by mini-css-extract-plugin
export default {"nav-list":"_1eu2O","navList":"_1eu2O","nav-item":"_3k06Z","navItem":"_3k06Z","active":"_3MYh5","nav-item-icon":"_2HbKe","navItemIcon":"_2HbKe","beta":"_4Gmpd"};